<template>
  <div class="wrap result-wrap result-wrap-o">
    <div class="content">
      <template v-if="type === 'loading'">
        <div class="icon loading"></div>
        <div class="text">{{ $t('loginning') }}</div>
      </template>
      <template v-else-if="type === 'success'">
        <div class="user-list">
          <div v-for="item in userList" class="item" :class="{ active: item.uid === crtUser.uid }" :key="item.uid" @click="crtUser = item">
            <div class="avatar" :style="{ backgroundImage: `url(${item.avatar})` }"></div>
            <div class="right">
              <div class="row top">
                <div class="name">{{ item.name }}</div>
                <div class="date" v-html="item.last_login.split(' ').join('<br />')"></div>
              </div>
              <div class="row info">
                <div class="txt">{{ $t('userinfo_level', {0: item.level}) }}</div>
                <div class="txt">{{ $t('userinfo_server', {0: item.server}) }}</div>
              </div>
            </div>
          </div>
        </div>
        <Button type="warning" :disabled="!crtUser.uid" @click="loginClick">{{ $t('test_confirm') }} </Button>
      </template>
      <template v-else-if="type === 'fail'">
        <div class="icon fail"></div>
        <div class="text">
          {{ $t('login_fail_2') }}
          <p class="code-tips" v-if="code > 0">{{ code }} - {{ (urlParams.gid === '60004' && code === 20016) ? $t('ENTROPY_20016') : $t(`KGSDK_${code}`) }}</p>
        </div>
      </template>
    </div>
    <div v-if="type === 'fail'" class="btns">
      <Button type="warning" @click="reLogin">{{ $t('try_again') }} </Button>
    </div>
  </div>
</template>

<script>
import { webSocialLogin, oauthGetUidList, oauthGetUserInfo } from '@/api'
export default {
  name: 'Result',
  data () {
    const loginData = this.$route.params.loginData || {}
    return {
      type: 'loading',
      urlParams: JSON.parse(window.localStorage.getItem('sdkParams') || '{}'),
      once_key: undefined,
      loginData,
      code: undefined,
      token: '',
      userList: [],
      crtUser: {}
    }
  },
  created () {
    this.login()
  },
  methods: {
    login () {
      const data = this.$route.params.loginData || {}
      // 网站登录，有 refer 需要回跳
      this.loginWithWebsite(data)
    },
    // 网页登录
    async loginWithWebsite (data) {
      const params = {
        game_id: this.urlParams.gid,
        device_id: 'fpoauth' + this.$utils.randomString(25),
        device_uuid: this.$utils.getUuid(),
        device_type: 'web',
        bind_type: this.$ENUM.SOCIAL_CODE_MAP[data.type],
        access_token: data.token,
        bind_info: {
          id: String(data.id),
          name: data.name,
          email: data.email || ''
        },
        lang: this.urlParams.lang
      }
      // dw passport 流程需要用到 fp_device_id 获取 fpid list
      if (data.type === this.$ENUM.SOCIAL_MAP.FUNPLUS_ID) {
        params.fp_device_id = data.fp_device_id
      }
      try {
        const res = await webSocialLogin(params)
        this.token = res.token
        const uidList = await oauthGetUidList({ game_id: this.urlParams.gid, game_project: this.urlParams.game_project || this.$ENUM.GAME_PROJECT_MAP[this.urlParams.gid], token: res.token })
        if (uidList.uid_list.length === 1) {
          this.crtUser = uidList.uid_list[0]
          this.loginClick()
        } else if (uidList.uid_list.length > 1) {
          this.userList = uidList.uid_list
          this.type = 'success'
        } else {
          if (this.urlParams.gid === '60004') {
            return this.setEntropy20016()
          }
          this.$msg.success(this.$t('KGSDK_20016'))
          this.type = 'fail'
          this.code = 20016
        }
      } catch (err) {
        if (this.urlParams.gid === '60004' && err.code === 20016) {
          return this.setEntropy20016()
        }
        this.$msg.success(this.$t(`KGSDK_${err.code}`))
        this.type = 'fail'
        this.code = err.code
      }
    },
    // entropy 登录 20016 时特殊提示
    setEntropy20016 () {
      this.$msg.success(this.$t(`ENTROPY_20016`))
      this.type = 'fail'
      this.code = 20016
    },
    reLogin () {
      this.$router.replace({ name: 'OauthLogin' })
    },
    loginClick () {
      const params = {
        game_id: Number(this.urlParams.gid),
        game_project: this.urlParams.game_project || this.$ENUM.GAME_PROJECT_MAP[this.urlParams.gid],
        token: this.token,
        uid: this.crtUser.uid
      }
      this.$Spin.show()
      oauthGetUserInfo(params)
        .then(userInfo => {
          if (this.urlParams.refer) {
            this.redirectBack(userInfo)
          } else {
            window.opener && window.opener.postMessage({ type: 'fpOauthLogin', data: { userInfo, token: this.token} }, '*')
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.$Spin.hide()
        })
    },
    redirectBack (userInfo) {
      let refer = decodeURIComponent(this.urlParams.refer)
      refer += refer.indexOf('?') > 0 ? '&' : '?'
      window.location.href = `${refer}${this.urlParams.refer_t}=${encodeURIComponent(this.token)}&${this.urlParams.refer_o}=${encodeURIComponent(userInfo.openid)}`
    }
  }
}
</script>

<style lang='less' scoped >
.r-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_success.png) center center no-repeat;
    background-size: 100% 100%;
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
  }
}
.wrap {
  height: 100% !important;
  padding: 32px;
  display: flex;
  flex-direction: column;
  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_fail.png) center center no-repeat;
    background-size: 100% 100%;
    &.success { background-image: url(~@img/icon_success.png); }
    &.fail { background-image: url(~@img/icon_fail.png); }
    &.loading {
      background-image: url(~@img/icon_loading.png);
      filter: contrast(0.5);
      animation: infiniteRotate linear 2s infinite;
    }
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
    text-align: center;
  }
  .code-tips {
    margin-top: 10px;
    font-size: 12px;
    line-height: 1.5;
    color: #777;
  }
}
@keyframes infiniteRotate {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.user-list {
  overflow-y: auto;
  width: 100%;
  flex: 1;
  overflow-y: auto;
  margin-bottom: 10px;
  .item {
    padding: 10px;
    border-radius: 7px;
    border: 1px solid #F1F1F1;
    background-color: #fff;
    display: flex;
    justify-content: stretch;
    cursor: pointer;
    & + .item {
      margin-top: 10px;
    }
    &:hover {
      border-color: rgba(255, 90, 0, 0.3);
    }
    &.active {
      border-color: rgba(255, 90, 0, 0.5);
    }
  }
  .avatar {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    overflow: hidden;
    background-size: 100% 100%;
  }
  .right {
    flex: 1;
    overflow: hidden;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
  }
  .name {
    font-size: 18px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 10px;
    flex: 1;
  }
  .date {
    font-size: 12px;
    white-space: nowrap;
    text-align: right;
  }
  .info {
    justify-content: flex-start;
    .txt {
      font-size: 12px;
      color: #999999;
      margin-right: 15px;
    }
  }
}
</style>
